module.exports = __webpack_public_path__ + "static/img/solution-page-banner.476413f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-page-banner.png
// module id = wD1U
// module chunks = 0